module.exports = __webpack_public_path__ + "static/fonts/open-sans-semibold.8f71281.ttf";